import styled from 'styled-components';
import bg from '../../assets/images/home_screen_bg.jpg';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	background-image: url(${bg});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	transition: opacity 0.3s ease;

	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledAppBottomRow = styled.div`
	position: absolute;
	left: 50%;
	bottom: 30px;
	transform: translateX(-50%);
	display: flex;
	gap: 20px;
	padding: 20px;
	border-radius: 30px;
	background-color: rgba(0, 0, 0, 0.5);
`;

const StyledMainMenu = styled.div`
	position: absolute;
	top: 50px;
	left: 50%;
	transform: translateX(-50%);
	display: grid;
	grid-template-columns: repeat(5, 60px);
	gap: 100px;
`;

export { StyledContainer, StyledAppBottomRow, StyledMainMenu };
